import http from '@/http/aisea/axios'
const resource = "/enterprise/voyage/histories";
const qs = require('qs');

export default {
  fetch(params) {
    return http.get(`${resource}`, {
      params: params
    });
  },

  getEnterpriseVoyageHistories(params) {
    return http.get(`${resource}`, {
      params: params,
      paramsSerializer: params => {
  
        let userIds = params.user_ids.flatMap(e => "&user_ids="+e).join("")
        let vesselIds = params.vessel_ids.flatMap(e => "&vessel_ids="+e).join("")
  
        delete params.user_ids
        delete params.vessel_ids
  
        return qs.stringify(params) + userIds + vesselIds;
      }
    });
  }
};
